import { get } from "services/network/endpoint"
import { dispatchHandler } from "services/utils/action"
import * as ActionTypes from "services/state/action-types"
import { BFF } from "services/network/routes"
import { TELEFONIA_MOVEL } from "./constants"

export function getProductsSharedData(callback, callbackFail) {
  return (dispatch) => {
    const config = {
      pathValues: { productLineName: TELEFONIA_MOVEL },
      client: BFF
    }
    const request = get("productsAll", config)

    return dispatch({
      type: ActionTypes.GET_PRODUCTS_SHARED_DATA,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}



// WEBPACK FOOTER //
// ./src/services/state/sharedData/action.js